var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RBtooltip"},[_vm._t("default"),_c('span',{staticClass:"RBtooltiptext"},[_vm._v(_vm._s(_vm.toolTipText))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }